@if (orderReturnData$ | async; as order) {
  @if (order.returnEntries) {
    <main id="main-content" class="main-content" role="main">
      <div class="page-header">
        <h1 class="page-title">
          Return Request Details
        </h1>
      </div>
      <div class="return-details">
        <div class="details-grid">
          <div class="detail-group">
            <div class="detail-item">
              <div class="detail-label">RMA #</div>
              <div class="detail-value">{{ order?.rmaNumber || '60449692' }}</div>
            </div>
            <div class="detail-item">
              <div class="detail-label">Account #</div>
              <div class="detail-value">{{ order?.accountNumber || '205174' }}</div>
            </div>
            <div class="detail-item">
              <div class="detail-label">Sold-to-Address</div>
              <div class="detail-value address">
                {{ order?.soldToAddress || 'ABC SUPPLY #417 25 SPRING MILL DRIVE MALVERN PA 19355-1202 United States' }}
              </div>
            </div>
            <div class="detail-item">
              <div class="detail-label">Account Phone</div>
              <div class="detail-value">{{ order?.accountPhone || '(610) 640-1852' }}</div>
            </div>
          </div>
          <div class="detail-group">
            <div class="detail-item">
              <div class="detail-label">Return Creation Date</div>
              <div class="detail-value">{{ order?.creationDate || '05/19/2025' }}</div>
            </div>
            <div class="detail-item">
              <div class="detail-label">Return Reason</div>
              <div class="detail-value">{{ order?.returnReason || 'Pricing' }}</div>
            </div>
            <div class="detail-item">
              <div class="detail-label">Ship-to-Address</div>
              <div class="detail-value address">
                {{ order?.shipToAddress || 'ABC SUPPLY #417 1 25 SPRING MILL DRIVE test PA 19355-1202 United States' }}
              </div>
            </div>
          </div>
          <div class="detail-group">
            <div class="detail-item">
              <div class="detail-label">Order #</div>
              <div class="detail-value">{{ order?.orderNumber || '3024041' }}</div>
            </div>
            <div class="detail-item">
              <div class="detail-label">Return Status</div>
              <div class="detail-value">{{ order?.status || 'Wait' }}</div>
            </div>
            <div class="detail-item">
              <div class="detail-label">Notes</div>
              <div class="detail-value">{{ order?.notes || '-' }}</div>
            </div>
          </div>
          <div class="detail-group">
            <div class="detail-item">
              <div class="detail-label">PO #</div>
              <div class="detail-value">{{ order?.poNumber || '98748888' }}</div>
            </div>
            <div class="detail-item">
              <div class="detail-label">Credit Memo #</div>
              <div class="detail-value">{{ order?.creditMemoNumber || '-' }}</div>
            </div>
            <div class="detail-item">
              <div class="detail-label">Attachments</div>
              <div class="detail-value">{{ order?.attachments || '-' }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="products-section">
        <table class="products-table" role="table" aria-label="Return products">
          <thead>
            <tr role="row">
              <th role="columnheader" scope="col">
                {{ 'knbrReturnOrderDetails.label.product' | cxTranslate }}
              </th>
              <th role="columnheader" scope="col">
                {{ 'knbrReturnOrderDetails.label.skuNumber' | cxTranslate }}
              </th>
              <th role="columnheader" scope="col">
                {{ 'knbrReturnOrderDetails.label.description' | cxTranslate }}
              </th>
              <th role="columnheader" scope="col">
                {{ 'knbrReturnOrderDetails.label.returnQty' | cxTranslate }}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (item of order.returnEntries; track item) {
              <tr role="row">
                <td role="gridcell">
                  <cx-media [container]="item.orderEntry?.product?.images?.PRIMARY" format="product"></cx-media>
                </td>
                <td role="gridcell">
                  <a class="product-sku">{{ item.orderEntry?.product?.code }}</a>
                </td>
                <td role="gridcell">
                  {{ item.orderEntry?.product?.name }}
                </td>
                <td role="gridcell">
                  {{ item?.expectedQuantity?.toLocaleString() }} {{ item?.uom }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <!-- Back Button -->
      <div class="back-to-list">
        <button type="button" class="back-btn" (click)="goBack()">
          {{ 'knbrReturnOrderDetails.actions.backOrderReturns' | cxTranslate }}
        </button>
      </div>
    </main>
  }
}